import { Link } from "react-router-dom";

export default function ProductCard({ image, category, name, description, slug }) {
  return (
    <div className="product-card">
      <div className="product-image">
        <img src={image} alt={name} loading="lazy"/>
      </div>

      <div className="product-info">
        <div className="product-category">{category}</div>
        <h3 className="product-name">{name}</h3>
        <p className="product-description">{description}</p>

        <Link to={`/product/${slug}`} className="product-link">
            Learn More
        </Link>
      </div>
    </div>
  );
}
